import { useQuery } from "react-query";
import { pagesApi } from "@/react/api/site/pagesApi";
import type { PageForRender } from "@/react/types/Page";

export interface UseGetPageProps {
  enabled?: boolean;
  id?: number | null;
}

export const PAGES_QUERY_KEY = ["site", "pages"];

export const useGetPage = ({ id, enabled = true }: UseGetPageProps) =>
  useQuery<PageForRender | null>({
    queryKey: [...PAGES_QUERY_KEY, id],
    queryFn: () => {
      if (id) {
        return pagesApi.show(id);
      }
      return null;
    },
    enabled: enabled && !!id,
  });
